<gc-top-nav-bar id="topNavBar" (hamburgerClick)="sidenav.toggle()" (dropdownMenuVisible)="this.doBlur = $event"></gc-top-nav-bar>
<gc-sidebar-nav #sidenav></gc-sidebar-nav>
<div class="contents" [ngClass]="{ blur: doBlur }">
  <router-outlet></router-outlet>
</div>
